if (!customElements.get('countdown-timer-bar')) {
  class CountdownBar extends HTMLElement {
    constructor() {
      super();

      this.slides = Array.from(this.querySelectorAll('.countdown-timer-bar__slide'));
      this.activeIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.section = this.closest('.section-countdown-timer-bar');

      // one countdown config per slide
      this.timers = this.slides.map((slide) => this.getTimerConfig(slide));

      this.prevButton = this.querySelector('.countdown-timer-bar__arrow--prev');
      this.nextButton = this.querySelector('.countdown-timer-bar__arrow--next');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.manualSwitch(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.manualSwitch(1));
      }

      // auto rotate, only when there is more than one promo
      this.autoInterval = null;
      if (this.slides.length > 1) {
        const intervalAttr = Number(this.getAttribute('data-autoplay-interval'));
        const autoplayInterval = intervalAttr > 0 ? intervalAttr : 3000;
        this.autoInterval = setInterval(() => {
          this.show(this.activeIndex + 1);
        }, autoplayInterval);
      }

      this.interval = setInterval(this.tick.bind(this), 1000);
      this.tick();

      this.calcHeight();
    }

    getTimerConfig(slide) {
      const enableMockTimer = slide.getAttribute('data-enable-mock-timer') === 'true';
      let userDate;
      let userTime;

      if (!enableMockTimer) {
        userDate = slide.getAttribute('data-date');
        userTime = slide.getAttribute('data-time');
      } else {
        // get data for infinite mock timer
        const INFINITE_DAYS = slide.getAttribute('data-enable-mock-picker-day')
          ? Number(slide.getAttribute('data-enable-mock-picker-day'))
          : 2;
        const DIFF_HOURS = slide.getAttribute('data-enable-mock-picker-hours')
          ? Number(slide.getAttribute('data-enable-mock-picker-hours'))
          : 3;
        const now = new Date();
        const futureDate = new Date(
          now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
        );
        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const day = String(futureDate.getDate()).padStart(2, '0');
        const hours = String(futureDate.getHours()).padStart(2, '0');
        const minutes = String(futureDate.getMinutes()).padStart(2, '0');
        userDate = `${year}-${month}-${day}`;
        userTime = `${hours}:${minutes}`;
      }

      return {
        slide,
        userDate,
        userTime,
        completed: slide.getAttribute('data-completed'),
        finished: false,
      };
    }

    updateTimer(timer) {
      const { slide, userDate, userTime, completed } = timer;

      const countdown = slide.querySelector('.countdown-timer-bar__main');
      const countdownHeading = slide.querySelector('.countdown-timer-bar__end');
      const daysEl = slide.querySelector('.countdown-timer-bar__days');
      const hoursEl = slide.querySelector('.countdown-timer-bar__hours');
      const minutesEl = slide.querySelector('.countdown-timer-bar__minutes');
      const secondsEl = slide.querySelector('.countdown-timer-bar__seconds');

      const countdownDate = new Date(`${userDate}T${userTime}`);
      const now = new Date();
      const distance = countdownDate.getTime() - now.getTime();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        timer.finished = true;
        if (completed === 'hide_section') {
          // remove this promo from rotation
          slide.style.display = 'none';
          slide.classList.remove('is-active');
          if (this.slides[this.activeIndex] === slide) {
            this.show(this.activeIndex + 1);
          }
        } else {
          // show_text
          if (countdown) countdown.style.display = 'none';
          if (countdownHeading) countdownHeading.style.display = 'flex';
        }
        return;
      }

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    tick() {
      let visibleCount = 0;

      this.timers.forEach((timer) => {
        if (!timer.finished) {
          this.updateTimer(timer);
        }
        if (timer.slide.style.display !== 'none') {
          visibleCount += 1;
        }
      });

      // all promos completed with "hide_section" -> hide the whole bar
      if (visibleCount === 0 && this.slides.length > 0) {
        clearInterval(this.interval);
        if (this.autoInterval) clearInterval(this.autoInterval);
        if (this.section) this.section.style.display = 'none';
      }
    }

    show(index) {
      const len = this.slides.length;
      if (len === 0) return;

      let i = ((index % len) + len) % len;
      let attempts = 0;
      // skip promos hidden by a completed countdown
      while (this.slides[i].style.display === 'none' && attempts < len) {
        i = (i + 1) % len;
        attempts += 1;
      }
      if (this.slides[i].style.display === 'none') return;

      this.slides.forEach((slide) => slide.classList.remove('is-active'));
      this.slides[i].classList.add('is-active');
      this.activeIndex = i;
    }

    manualSwitch(direction) {
      // user took control: stop auto rotation until page refresh
      if (this.autoInterval) {
        clearInterval(this.autoInterval);
        this.autoInterval = null;
      }
      this.show(this.activeIndex + direction);
    }

    calcHeight() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.documentElement.style.setProperty("--countdown-bar-height", `${entry.boundingClientRect.height}px`);
          } else {
            document.documentElement.style.setProperty("--countdown-bar-height", "0px");
          }
        })
      });

      observer.observe(this);
    }
  }

  customElements.define("countdown-timer-bar", CountdownBar);
}
